import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { ReactComponent } from "../assets/definition.svg";
import { ReactComponent as ReactComponent_1 } from "../assets/dashboard.svg";
import { ReactComponent as ReactComponent_2 } from "../assets/model.svg";
import { ReactComponent as ReactComponent_3 } from "../assets/admin.svg";
import { ReactComponent as ReactComponent_4 } from "../assets/info.svg";
import { ReactComponent as ReactComponent_5 } from "../assets/document.svg";
import { Fa_ISize, Fa_IconOption, Fa_i } from "../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { item, map as map_1, tryHead, toArray, empty as empty_1, append as append_1, singleton as singleton_1, sortBy, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { nonSeeded } from "../fable_modules/fable-library-js.4.24.0/Random.js";
import { equals, createObj, comparePrimitives } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { interpolate, toText, join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { map, unwrap, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { int32_type, record_type, string_type, class_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { InfoPanel, ProjectPage__OnClick_Z11029FF1, ProjectPage__get_Href, ProjectPage, Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F, Feliz_Router_Router__Router_formatQueryPath_Static_6F3B930F, SearchParams } from "../ClientTypes.fs.js";
import { useFeliz_React__React_useFetch_Static_6ADA66EC, Fetched$1_toOption_50D43789 } from "../hooks/UseFetch.fs.js";
import { count } from "../Api/Tags.fs.js";
import { SearchParams_tagSearchParams } from "../Api/SearchParams.fs.js";
import { System_Int32__Int32_ToLocaleString } from "../Prelude.fs.js";
import { Action_Category, DomainEntities } from "../DomainEvents.fs.js";
import { ofList } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { ofList as ofList_1 } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { single } from "../Api/EquipmentTypes.fs.js";
import { System_DateTimeOffset__DateTimeOffset_ToLocaleDateString, EPM_Domain_Events_Action_Category__Category_ToUrlString } from "../Api/../Prelude.fs.js";
import { count as count_1 } from "../Api/Activities.fs.js";
import { count as count_2 } from "../Api/Documents.fs.js";
import { utcNow } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import { projectBreakdown } from "../Api/Dashboard.fs.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.Recharts.4.3.0/../Feliz.2.9.0/Interop.fs.js";
import { ResponsiveContainer, RadialBarChart, RadialBar, Legend, PolarAngleAxis } from "recharts";
import { ProjectContext__get_HasAccessToAdmin, useFeliz_React__React_useProjectContext_Static } from "../hooks/UseProjectContext.fs.js";
import "./Home.scss";


export function DefinitionIcon(b) {
    const props = keyValueList(b, 1);
    return react.createElement(ReactComponent, props);
}

export function DashboardIcon(b) {
    const props = keyValueList(b, 1);
    return react.createElement(ReactComponent_1, props);
}

export function DiagnosticIcon(b) {
    const props = keyValueList(b, 1);
    return react.createElement(ReactComponent_1, props);
}

export function ModelIcon(b) {
    const props = keyValueList(b, 1);
    return react.createElement(ReactComponent_2, props);
}

export function AdminIcon(b) {
    const props = keyValueList(b, 1);
    return react.createElement(ReactComponent_3, props);
}

export function InfoIcon(b) {
    const props = keyValueList(b, 1);
    return react.createElement(ReactComponent_4, props);
}

export function DocumentIcon(b) {
    const props = keyValueList(b, 1);
    return react.createElement(ReactComponent_5, props);
}

export function HelpdeskIcon(_arg) {
    return Fa_i(ofArray([new Fa_IconOption(11, ["far fa-comment-dots"]), new Fa_IconOption(0, [new Fa_ISize(7, [])]), new Fa_IconOption(15, ["wall-icon"])]), []);
}

const diagnosticUrl = "https://levenmouth.taddev.co.uk/";

const diagnosticTitle = "Diagnostic";

const reportsTitle = "Reports";

const projectWallBackgrounds = sortBy((_arg) => nonSeeded().Next1(100), ofArray(["https://epmdata.blob.core.windows.net/assets/images/project/0.jpg", "https://epmdata.blob.core.windows.net/assets/images/project/1.jpg", "https://epmdata.blob.core.windows.net/assets/images/project/2.jpg", "https://epmdata.blob.core.windows.net/assets/images/project/3.jpg", "https://epmdata.blob.core.windows.net/assets/images/project/4.jpg", "https://epmdata.blob.core.windows.net/assets/images/project/5.jpg"]), {
    Compare: comparePrimitives,
});

const progressWallBackgrounds = sortBy((_arg) => nonSeeded().Next1(100), ofArray(["https://epmdata.blob.core.windows.net/assets/images/progress/0.jpg", "https://epmdata.blob.core.windows.net/assets/images/progress/1.jpg", "https://epmdata.blob.core.windows.net/assets/images/progress/2.jpg", "https://epmdata.blob.core.windows.net/assets/images/progress/3.jpg", "https://epmdata.blob.core.windows.net/assets/images/progress/4.jpg"]), {
    Compare: comparePrimitives,
});

const documentsWallBackgrounds = sortBy((_arg) => nonSeeded().Next1(100), ofArray(["https://epmdata.blob.core.windows.net/assets/images/documents/0.jpg", "https://epmdata.blob.core.windows.net/assets/images/documents/1.jpg", "https://epmdata.blob.core.windows.net/assets/images/documents/2.jpg", "https://epmdata.blob.core.windows.net/assets/images/documents/3.jpg", "https://epmdata.blob.core.windows.net/assets/images/documents/4.jpg"]), {
    Compare: comparePrimitives,
});

function WallItem(wallItemInputProps) {
    let elems_1;
    const background = wallItemInputProps.background;
    const hasImage = wallItemInputProps.hasImage;
    const content = wallItemInputProps.content;
    const onClick = wallItemInputProps.onClick;
    const href = wallItemInputProps.href;
    return createElement("li", createObj(ofArray([["className", join(" ", ["boxgrid__item"])], (elems_1 = [createElement("a", {
        href: href,
        onClick: onClick,
        className: join(" ", toList(delay(() => append(singleton("box-item"), delay(() => append(hasImage ? singleton("box-item--image") : empty(), delay(() => singleton(background)))))))),
        children: reactApi.Children.toArray(Array.from(content)),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function EmptyWallItem() {
    let elems;
    return createElement("li", createObj(ofArray([["className", join(" ", ["boxgrid__item--push"])], (elems = [createElement("div", {
        className: join(" ", ["box-item"]),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function ExtWallItemGeneric(extWallItemGenericInputProps) {
    let elems_1, elems;
    const target = extWallItemGenericInputProps.target;
    const backgroundClass = extWallItemGenericInputProps.backgroundClass;
    const icon = extWallItemGenericInputProps.icon;
    const title = extWallItemGenericInputProps.title;
    const href = extWallItemGenericInputProps.href;
    const targetValue = defaultArg(target, "_blank");
    return createElement("li", createObj(ofArray([["className", join(" ", ["boxgrid__item"])], (elems_1 = [createElement("a", createObj(ofArray([["href", href], ["target", targetValue], ["className", join(" ", ["box-item", backgroundClass, "box-item--image"])], (elems = [createElement("figure", createObj(Helpers_combineClasses("image", ofArray([["className", "is-64x64"], ["children", icon(singleton_1(["className", "wall-icon"]))]])))), createElement("p", {
        children: [title],
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function ExtWallItem(extWallItemInputProps) {
    const title = extWallItemInputProps.title;
    const href = extWallItemInputProps.href;
    return createElement(ExtWallItemGeneric, {
        href: href,
        title: title,
        icon: DashboardIcon,
        backgroundClass: "indigo",
    });
}

function ExtWallItemReport(extWallItemReportInputProps) {
    const title = extWallItemReportInputProps.title;
    const href = extWallItemReportInputProps.href;
    return createElement(ExtWallItemGeneric, {
        href: href,
        title: title,
        icon: InfoIcon,
        backgroundClass: "orange",
    });
}

export class Circle extends Record {
    constructor(Image, Text$) {
        super();
        this.Image = Image;
        this.Text = Text$;
    }
}

export function Circle_$reflection() {
    return record_type("EPM.App.Project.Home.Circle", [], Circle, () => [["Image", class_type("Fable.React.ReactElement", undefined)], ["Text", string_type]]);
}

function backgroundImages(url) {
    return ["backgroundImage", `Url(${url}),linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab)`];
}

function Wall(wallInputProps) {
    let elems_2, elems_1, elems_4;
    const background = wallInputProps.background;
    const items = wallInputProps.items;
    const circle = wallInputProps.circle;
    const backgroundImage = wallInputProps.backgroundImage;
    const controlButtons = wallInputProps.controlButtons;
    const subtitle = wallInputProps.subtitle;
    const title = wallInputProps.title;
    const children = ofArray([createElement("header", createObj(ofArray([["style", createObj(toList(delay(() => ((backgroundImage == null) ? singleton(backgroundImages(background)) : singleton(backgroundImages(backgroundImage))))))], (elems_2 = [createElement("h1", {
        children: [title],
    }), createElement("p", {
        children: [subtitle],
    }), createElement("div", createObj(ofArray([["className", "controls"], (elems_1 = toList(delay(() => {
        let matchValue;
        return append((matchValue = controlButtons, (matchValue == null) ? (empty()) : singleton(matchValue)), delay(() => {
            let elems;
            return singleton(createElement("div", createObj(ofArray([["className", "user"], (elems = [circle.Image, createElement("span", {
                className: "user-name",
                children: circle.Text,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["className", "section__content"], (elems_4 = [createElement("ul", {
        className: "boxgrid",
        children: reactApi.Children.toArray(Array.from(items)),
    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))]);
    return createElement("article", {
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

function TagCount(tagCountInputProps) {
    const subtitle = tagCountInputProps.subtitle;
    const searchParams = tagCountInputProps.searchParams;
    const projectId = tagCountInputProps.projectId;
    const tagParams = append_1(searchParams, singleton_1(new SearchParams(0, ["tag"])));
    const tagCountFetch = Fetched$1_toOption_50D43789(useFeliz_React__React_useFetch_Static_6ADA66EC((tagParams_1) => count(projectId, tagParams_1), SearchParams_tagSearchParams(tagParams), [projectId]));
    return createElement(WallItem, {
        href: Feliz_Router_Router__Router_formatQueryPath_Static_6F3B930F(tagParams, true),
        onClick: (e) => {
            e.preventDefault();
            Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(tagParams, true);
        },
        content: toList(delay(() => {
            let matchValue;
            return append((matchValue = tagCountFetch, (matchValue == null) ? singleton(createElement("p", {
                children: ["..."],
            })) : singleton(createElement("h2", {
                children: [System_Int32__Int32_ToLocaleString(matchValue)],
            }))), delay(() => singleton(createElement("p", {
                children: [defaultArg(subtitle, "Tags")],
            }))));
        })),
        hasImage: false,
        background: "lightBlue",
    });
}

function TagByLabelCount(tagByLabelCountInputProps) {
    const value = tagByLabelCountInputProps.value;
    const label = tagByLabelCountInputProps.label;
    const projectId = tagByLabelCountInputProps.projectId;
    const key = tagByLabelCountInputProps.$key;
    return createElement(TagCount, {
        projectId: projectId,
        searchParams: singleton_1(new SearchParams(5, [new DomainEntities(0, []), ofList(singleton_1([label, ofList_1(singleton_1(value), {
            Compare: comparePrimitives,
        })]), {
            Compare: comparePrimitives,
        })])),
        subtitle: value,
    });
}

function TagByEquipmentTypeCount(tagByEquipmentTypeCountInputProps) {
    const equipmentTypeId = tagByEquipmentTypeCountInputProps.equipmentTypeId;
    const projectId = tagByEquipmentTypeCountInputProps.projectId;
    const key = tagByEquipmentTypeCountInputProps.$key;
    const equipmentTypeFetch = useFeliz_React__React_useFetch_Static_6ADA66EC((equipmentTypeId_1) => single(projectId, equipmentTypeId_1), equipmentTypeId, [projectId, equipmentTypeId]);
    const text = (equipmentTypeFetch.tag === 0) ? undefined : ((equipmentTypeFetch.tag === 1) ? "..." : ((equipmentTypeFetch.tag === 3) ? "?" : equipmentTypeFetch.fields[0].Name));
    return createElement(TagCount, {
        projectId: projectId,
        searchParams: singleton_1(new SearchParams(2, [equipmentTypeId, new DomainEntities(10, [])])),
        subtitle: unwrap(text),
    });
}

function ActivityCount(activityCountInputProps) {
    const projectId = activityCountInputProps.projectId;
    const activityParams = ofArray([["actionCategory", EPM_Domain_Events_Action_Category__Category_ToUrlString(new Action_Category(0, []))], ["completed-status", "completed=true"]]);
    const urlParams = ofArray([new SearchParams(0, ["activity"]), new SearchParams(10, ["toDo"])]);
    const activityCountFetch = Fetched$1_toOption_50D43789(useFeliz_React__React_useFetch_Static_6ADA66EC((activityParams_1) => count_1(projectId, activityParams_1), ofArray([["actionCategory", EPM_Domain_Events_Action_Category__Category_ToUrlString(new Action_Category(0, []))], ["completed-status", "completed=false"]]), [projectId]));
    return createElement(WallItem, {
        href: Feliz_Router_Router__Router_formatQueryPath_Static_6F3B930F(urlParams, false),
        onClick: (e) => {
            e.preventDefault();
            Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(urlParams, false);
        },
        content: toList(delay(() => {
            let matchValue;
            return append((matchValue = activityCountFetch, (matchValue == null) ? singleton(createElement("p", {
                children: ["..."],
            })) : singleton(createElement("h2", {
                children: [System_Int32__Int32_ToLocaleString(matchValue)],
            }))), delay(() => singleton(createElement("p", {
                children: ["Activities To Do"],
            }))));
        })),
        hasImage: false,
        background: "lightBlue",
    });
}

function DocumentCount(documentCountInputProps) {
    const projectId = documentCountInputProps.projectId;
    const urlParams = singleton_1(new SearchParams(0, ["document"]));
    const activityCountFetch = Fetched$1_toOption_50D43789(useFeliz_React__React_useFetch_Static_6ADA66EC((documentParams) => count_2(projectId, documentParams), empty_1(), [projectId]));
    return createElement(WallItem, {
        href: Feliz_Router_Router__Router_formatQueryPath_Static_6F3B930F(urlParams, true),
        onClick: (e) => {
            e.preventDefault();
            Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(urlParams, true);
        },
        content: toList(delay(() => {
            let matchValue;
            return append((matchValue = activityCountFetch, (matchValue == null) ? singleton(createElement("p", {
                children: ["..."],
            })) : singleton(createElement("h2", {
                children: [System_Int32__Int32_ToLocaleString(matchValue)],
            }))), delay(() => singleton(createElement("p", {
                children: ["Documents"],
            }))));
        })),
        hasImage: false,
        background: "indigo",
    });
}

function OpenDocumentTrackingCount(openDocumentTrackingCountInputProps) {
    const projectId = openDocumentTrackingCountInputProps.projectId;
    const activityParams = ofArray([["actionCategory", EPM_Domain_Events_Action_Category__Category_ToUrlString(new Action_Category(3, []))], ["completed-status", "completed=false"]]);
    const behindParams = ofArray([["actionCategory", EPM_Domain_Events_Action_Category__Category_ToUrlString(new Action_Category(3, []))], ["completed-status", `behind=${System_DateTimeOffset__DateTimeOffset_ToLocaleDateString(utcNow())}`]]);
    const urlParams = ofArray([new SearchParams(0, ["documentTracking"]), new SearchParams(10, ["toDo"])]);
    const activityCountFetch = Fetched$1_toOption_50D43789(useFeliz_React__React_useFetch_Static_6ADA66EC((activityParams_1) => count_1(projectId, activityParams_1), activityParams, [projectId]));
    const behindCountFetch = Fetched$1_toOption_50D43789(useFeliz_React__React_useFetch_Static_6ADA66EC((activityParams_2) => count_1(projectId, activityParams_2), behindParams, [projectId]));
    return createElement(WallItem, {
        href: Feliz_Router_Router__Router_formatQueryPath_Static_6F3B930F(urlParams, false),
        onClick: (e) => {
            e.preventDefault();
            Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(urlParams, false);
        },
        content: toList(delay(() => {
            let matchValue;
            return append((matchValue = activityCountFetch, (matchValue == null) ? singleton(createElement("p", {
                children: ["..."],
            })) : singleton(createElement("h2", {
                children: [System_Int32__Int32_ToLocaleString(matchValue)],
            }))), delay(() => {
                let matchValue_1, behind_1, behind_2;
                return append((matchValue_1 = behindCountFetch, (matchValue_1 != null) ? ((matchValue_1 === 0) ? ((behind_1 = (matchValue_1 | 0), singleton(defaultOf()))) : ((behind_2 = (matchValue_1 | 0), singleton(createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["title", `Behind ${System_Int32__Int32_ToLocaleString(behind_2)}`], ["className", "has-text-warning"], ["className", "is-medium"], ["children", Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-exclamation-triangle"]), new Fa_IconOption(0, [new Fa_ISize(3, [])])]), [])]])))))))) : singleton(defaultOf())), delay(() => singleton(createElement("p", {
                    children: ["Documents left"],
                }))));
            }));
        })),
        hasImage: false,
        background: "mint",
    });
}

function OpenPunchlistCount(openPunchlistCountInputProps) {
    const projectId = openPunchlistCountInputProps.projectId;
    const activityParams = ofArray([["actionCategory", EPM_Domain_Events_Action_Category__Category_ToUrlString(new Action_Category(2, []))], ["completed-status", "completed=false"]]);
    const behindParams = ofArray([["actionCategory", EPM_Domain_Events_Action_Category__Category_ToUrlString(new Action_Category(2, []))], ["completed-status", `behind=${System_DateTimeOffset__DateTimeOffset_ToLocaleDateString(utcNow())}`]]);
    const urlParams = ofArray([new SearchParams(0, ["punchList"]), new SearchParams(10, ["toDo"])]);
    const activityCountFetch = Fetched$1_toOption_50D43789(useFeliz_React__React_useFetch_Static_6ADA66EC((activityParams_1) => count_1(projectId, activityParams_1), activityParams, [projectId]));
    const behindCountFetch = Fetched$1_toOption_50D43789(useFeliz_React__React_useFetch_Static_6ADA66EC((activityParams_2) => count_1(projectId, activityParams_2), behindParams, [projectId]));
    return createElement(WallItem, {
        href: Feliz_Router_Router__Router_formatQueryPath_Static_6F3B930F(urlParams, false),
        onClick: (e) => {
            e.preventDefault();
            Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(urlParams, false);
        },
        content: toList(delay(() => {
            let matchValue;
            return append((matchValue = activityCountFetch, (matchValue == null) ? singleton(createElement("p", {
                children: ["..."],
            })) : singleton(createElement("h2", {
                children: [System_Int32__Int32_ToLocaleString(matchValue)],
            }))), delay(() => {
                let matchValue_1, behind_1, behind_2;
                return append((matchValue_1 = behindCountFetch, (matchValue_1 != null) ? ((matchValue_1 === 0) ? ((behind_1 = (matchValue_1 | 0), singleton(defaultOf()))) : ((behind_2 = (matchValue_1 | 0), singleton(createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["title", `Behind ${System_Int32__Int32_ToLocaleString(behind_2)}`], ["className", "has-text-warning"], ["className", "is-medium"], ["children", Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-exclamation-triangle"]), new Fa_IconOption(0, [new Fa_ISize(3, [])])]), [])]])))))))) : singleton(defaultOf())), delay(() => singleton(createElement("p", {
                    children: ["Open Punchlist"],
                }))));
            }));
        })),
        hasImage: false,
        background: "mint",
    });
}

export class Point extends Record {
    constructor(name, max, value, fill) {
        super();
        this.name = name;
        this.max = (max | 0);
        this.value = (value | 0);
        this.fill = fill;
    }
}

export function Point_$reflection() {
    return record_type("EPM.App.Project.Home.Point", [], Point, () => [["name", string_type], ["max", int32_type], ["value", int32_type], ["fill", string_type]]);
}

function ProgressChart(progressChartInputProps) {
    let value_4, properties_5, elements;
    const projectId = progressChartInputProps.projectId;
    const progressPage = new ProjectPage(3, [projectId]);
    const progressFetch = Fetched$1_toOption_50D43789(useFeliz_React__React_useFetch_Static_6ADA66EC((activityParams_1) => projectBreakdown(projectId, activityParams_1), singleton_1(["actionCategory", EPM_Domain_Events_Action_Category__Category_ToUrlString(new Action_Category(0, []))]), [projectId]));
    const actualPercentComplete = map((p) => {
        if (p.Total === 0) {
            return 0;
        }
        else {
            return (p.Completed / p.Total) * 100;
        }
    }, progressFetch);
    const exceptedPercentComplete = map((p_1) => {
        if (p_1.Total === 0) {
            return 0;
        }
        else {
            return (p_1.Planned / p_1.Total) * 100;
        }
    }, progressFetch);
    const isBehind = defaultArg(map((progress) => (progress.Completed < progress.Planned), progressFetch), false);
    let data;
    const dependencies_1 = [progressFetch];
    data = reactApi.useMemo(() => {
        if (progressFetch != null) {
            const progress_1 = progressFetch;
            return ofArray([new Point("Planned", progress_1.Total, progress_1.Planned, "#83a6ed"), new Point("Actual", progress_1.Total, progress_1.Completed, (progress_1.Completed > progress_1.Planned) ? "#82ca9d" : "#DD8680")]);
        }
        else {
            return ofArray([new Point("Planned", 100, 0, "#83a6ed"), new Point("Actual", 100, 0, "#82ca9d")]);
        }
    }, dependencies_1);
    let chart_1;
    const properties_6 = ofArray([(value_4 = (100 + "%"), (equals(value_4, 100 + "%") ? true : equals(value_4, 100 + "%")) ? ["width", 99 + "%"] : ["width", value_4]), ["height", 100 + "%"], ["children", (properties_5 = ofArray([["barSize", 8], ["innerRadius", 60 + "%"], ["outerRadius", 90 + "%"], ["cx", 50 + "%"], ["cy", 55 + "%"], ["startAngle", 90], ["endAngle", -270], ["background", true], ["clockWise", true], ["margin", {
        top: defaultArg(5, 0),
        right: defaultArg(2, 0),
        left: defaultArg(2, 0),
        bottom: defaultArg(2, 0),
    }], ["data", toArray(data)], ["cursor", "pointer"], (elements = toList(delay(() => append(singleton(reactApi_1.createElement(PolarAngleAxis, {
        type: "number",
        dataKey: (point) => point.max,
        tick: false,
    })), delay(() => {
        let matchValue;
        return append((matchValue = actualPercentComplete, (matchValue != null) ? singleton(createElement("text", {
            children: toText(interpolate("%.2f%P()%%", [matchValue])),
            x: 50 + "%",
            y: 64 + "%",
            className: "progress-percent",
            textAnchor: "middle",
            fontSize: 0.8,
            fill: isBehind ? "#DD8680" : "#82ca9d",
        })) : (empty())), delay(() => {
            let matchValue_1;
            return append((matchValue_1 = exceptedPercentComplete, (matchValue_1 != null) ? singleton(createElement("text", {
                children: toText(interpolate("%.2f%P()%%", [matchValue_1])),
                x: 50 + "%",
                y: 55 + "%",
                fontSize: 0.8,
                className: "progress-percent",
                textAnchor: "middle",
                fill: "#83a6ed",
            })) : (empty())), delay(() => append(singleton(reactApi_1.createElement(Legend, {
                verticalAlign: "top",
                layout: "horizontal",
                iconType: "rect",
                align: "center",
            })), delay(() => singleton(reactApi_1.createElement(RadialBar, {
                dataKey: (point_1) => point_1.value,
            }))))));
        }));
    })))), ["children", ["children", reactApi.Children.toArray(Array.from(elements))]])]), reactApi_1.createElement(RadialBarChart, createObj(properties_5)))]]);
    chart_1 = reactApi_1.createElement(ResponsiveContainer, createObj(properties_6));
    return createElement(WallItem, {
        href: ProjectPage__get_Href(progressPage),
        onClick: (e) => {
            ProjectPage__OnClick_Z11029FF1(progressPage, e);
        },
        content: singleton_1(chart_1),
        hasImage: false,
        background: "grey",
    });
}

export class SubPoint extends Record {
    constructor(name, value) {
        super();
        this.name = name;
        this.value = (value | 0);
    }
}

export function SubPoint_$reflection() {
    return record_type("EPM.App.Project.Home.SubPoint", [], SubPoint, () => [["name", string_type], ["value", int32_type]]);
}

export function Home(homeInputProps) {
    const projectId = homeInputProps.projectId;
    const projectContext = useFeliz_React__React_useProjectContext_Static();
    let projectWall_1;
    const definitionPage = new ProjectPage(1, [projectId]);
    const definition = createElement(WallItem, {
        href: ProjectPage__get_Href(definitionPage),
        onClick: (e) => {
            ProjectPage__OnClick_Z11029FF1(definitionPage, e);
        },
        content: ofArray([createElement("figure", createObj(Helpers_combineClasses("image", ofArray([["className", "is-64x64"], ["children", DefinitionIcon([["className", "wall-icon"]])]])))), createElement("p", {
            children: ["Definition"],
        })]),
        hasImage: false,
        background: "teal",
    });
    let model_1;
    const matchValue = tryHead(projectContext.Config.Models);
    if (matchValue != null) {
        const modelPage = new ProjectPage(4, [projectId, matchValue.SketchfabId]);
        model_1 = createElement(WallItem, {
            href: ProjectPage__get_Href(modelPage),
            onClick: (e_1) => {
                ProjectPage__OnClick_Z11029FF1(modelPage, e_1);
            },
            content: ofArray([createElement("figure", createObj(Helpers_combineClasses("image", ofArray([["className", "is-64x64"], ["children", ModelIcon([["className", "wall-icon"]])]])))), createElement("p", {
                children: ["3D Model"],
            })]),
            hasImage: false,
            background: "indigo",
        });
    }
    else {
        model_1 = defaultOf();
    }
    let projectInfo;
    const infoParams = singleton_1(new SearchParams(4, [new InfoPanel(0, [])]));
    projectInfo = createElement(WallItem, {
        href: Feliz_Router_Router__Router_formatQueryPath_Static_6F3B930F(infoParams, false),
        onClick: (e_2) => {
            e_2.preventDefault();
            Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(infoParams, false);
        },
        content: ofArray([createElement("figure", createObj(Helpers_combineClasses("image", ofArray([["className", "is-64x64"], ["children", InfoIcon([["className", "wall-icon"]])]])))), createElement("p", {
            children: ["Info"],
        })]),
        hasImage: false,
        background: "mint",
    });
    let admin;
    if (ProjectContext__get_HasAccessToAdmin(projectContext)) {
        const adminPage = new ProjectPage(5, [projectId, "tag"]);
        admin = createElement(WallItem, {
            href: ProjectPage__get_Href(adminPage),
            onClick: (e_3) => {
                ProjectPage__OnClick_Z11029FF1(adminPage, e_3);
            },
            content: ofArray([createElement("figure", createObj(Helpers_combineClasses("image", ofArray([["className", "is-64x64"], ["children", AdminIcon([["className", "wall-icon"]])]])))), createElement("p", {
                children: ["Admin"],
            })]),
            hasImage: false,
            background: "orange",
        });
    }
    else {
        admin = createElement(EmptyWallItem, null);
    }
    projectWall_1 = createElement(Wall, {
        title: projectContext.Config.Name,
        subtitle: defaultArg(projectContext.Config.Description, ""),
        backgroundImage: unwrap(map((i) => i.Url, tryHead(projectContext.Config.BackgroundImages))),
        circle: new Circle(createElement("img", {
            src: projectContext.User.picture,
        }), projectContext.User.name),
        items: toList(delay(() => append(singleton(definition), delay(() => append(singleton(createElement(TagCount, {
            projectId: projectId,
            searchParams: empty_1(),
        })), delay(() => {
            let matchValue_1;
            return append((matchValue_1 = projectContext.Config.ProjectWall, (matchValue_1 != null) ? map_1((tile) => {
                if (tile.tag === 0) {
                    const equipmentTypeId = tile.fields[0];
                    return createElement(TagByEquipmentTypeCount, {
                        key: equipmentTypeId,
                        $key: equipmentTypeId,
                        projectId: projectId,
                        equipmentTypeId: equipmentTypeId,
                    });
                }
                else {
                    const value_31 = tile.fields[1];
                    const key_13 = tile.fields[0];
                    const $key5E639C39 = `${key_13}:${value_31}`;
                    return createElement(TagByLabelCount, {
                        key: $key5E639C39,
                        $key: $key5E639C39,
                        projectId: projectId,
                        label: key_13,
                        value: value_31,
                    });
                }
            }, matchValue_1.CustomTiles) : (empty())), delay(() => append(singleton(model_1), delay(() => append(singleton(createElement(EmptyWallItem, null)), delay(() => append(singleton(projectInfo), delay(() => singleton(admin)))))))));
        })))))),
        background: item(0, projectWallBackgrounds),
    });
    let progressWall;
    let dashboard;
    const dashboardPage = new ProjectPage(2, [projectId]);
    dashboard = createElement(WallItem, {
        href: ProjectPage__get_Href(dashboardPage),
        onClick: (e_4) => {
            ProjectPage__OnClick_Z11029FF1(dashboardPage, e_4);
        },
        content: ofArray([createElement("figure", createObj(Helpers_combineClasses("image", ofArray([["className", "is-64x64"], ["children", DashboardIcon([["className", "wall-icon"]])]])))), createElement("p", {
            children: ["Dashboard"],
        })]),
        hasImage: false,
        background: "yellow",
    });
    const laddr = createElement(ExtWallItemGeneric, {
        href: "https://www.unasys.com",
        title: "LADDR",
        icon: HelpdeskIcon,
        backgroundClass: "lightBlue",
    });
    const report = createElement(ExtWallItemReport, {
        href: "http://epmreports.co.uk?proj=" + projectContext.Config.Name,
        title: reportsTitle,
    });
    const diagnostic = createElement(ExtWallItem, {
        href: diagnosticUrl,
        title: diagnosticTitle,
    });
    progressWall = createElement(Wall, {
        title: "Progress",
        subtitle: "",
        circle: new Circle(Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-chart-pie"]), new Fa_IconOption(0, [new Fa_ISize(8, [])])]), []), ""),
        items: ofArray([createElement(ProgressChart, {
            projectId: projectId,
        }), report, laddr, createElement(EmptyWallItem, null), createElement(ActivityCount, {
            projectId: projectId,
        }), createElement(OpenPunchlistCount, {
            projectId: projectId,
        }), createElement(EmptyWallItem, null), dashboard]),
        background: item(0, progressWallBackgrounds),
    });
    const documentWall = createElement(Wall, {
        title: "Documents",
        subtitle: "",
        circle: new Circle(Fa_i(ofArray([new Fa_IconOption(11, ["far fa-file-alt"]), new Fa_IconOption(0, [new Fa_ISize(8, [])])]), []), ""),
        items: ofArray([createElement(DocumentCount, {
            projectId: projectId,
        }), createElement(EmptyWallItem, null), createElement(OpenDocumentTrackingCount, {
            projectId: projectId,
        }), createElement(EmptyWallItem, null)]),
        background: item(0, documentsWallBackgrounds),
    });
    return createElement("section", {
        className: join(" ", ["project-home", "wall"]),
        children: reactApi.Children.toArray([projectWall_1, progressWall, documentWall]),
    });
}

